// Níveis de superusuário
export const SUPERUSER_LEVELS = {
  1: "Admin",
  2: "Gerente",
  3: "Supervisor",
  4: "Atendente",
};

// Módulos do sistema com suas permissões
export const SYSTEM_MODULES = [
  "Meus Agentes",
  "Criar Agente",
  "Playground",
  "Chat",
  "Base de Clientes",
  "Pipeline CRM",
  "Agenda",
  "Templates",
  "Automações",
  "WhatsApp",
  "Integrações",
  "Personalizações",
  "Publicações",
  "Estatísticas",
  "Minha Empresa",
  "Meu Perfil",
  "Tags & Categorias",
  "Suporte",
];

// Ações de permissão
export const PERMISSION_ACTIONS = [
  { value: "create", label: "Criar" },
  { value: "read", label: "Visualizar" },
  { value: "update", label: "Editar" },
  { value: "delete", label: "Excluir" },
];

// Formatação de CPF
export const formatCPF = (cpf) => {
  if (!cpf) return "";

  const cleaned = cpf.replace(/\D/g, "");

  if (cleaned.length <= 11) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  return cpf;
};

// Preparar dados do usuário para envio à API
export const prepareUserData = (formData) => {
  const data = { ...formData };

  // Remove formatação do CPF
  if (data.cpf) {
    data.cpf = data.cpf.replace(/\D/g, "");
  }

  // Remove formatação do telefone
  if (data.phone) {
    data.phone = data.phone.replace(/\D/g, "");
  }

  if (data.mobile) {
    data.mobile = data.mobile.replace(/\D/g, "");
  }

  // Define is_superuser baseado no superuser_level
  if (data.superuser_level && data.superuser_level > 0) {
    data.is_superuser = 1;
  } else {
    data.is_superuser = 0;
  }

  // Remove campos vazios
  Object.keys(data).forEach((key) => {
    if (data[key] === "" || data[key] === null || data[key] === undefined) {
      delete data[key];
    }
  });

  return data;
};

// Verificar se usuário pode criar outro usuário com determinado nível
export const canCreateUserWithLevel = (currentUserLevel, targetLevel) => {
  // Admin pode criar qualquer nível
  if (currentUserLevel === 1) return true;

  // Gerente pode criar supervisor e atendente
  if (currentUserLevel === 2) return [3, 4].includes(targetLevel);

  // Supervisor pode criar apenas atendente
  if (currentUserLevel === 3) return targetLevel === 4;

  // Atendente não pode criar usuários
  return false;
};

// Obter opções de nível disponíveis para criação
export const getAvailableLevels = (currentUserLevel) => {
  const levels = [];

  if (currentUserLevel === 1) {
    // Admin pode criar todos os níveis
    levels.push(
      { value: 1, label: "Admin" },
      { value: 2, label: "Gerente" },
      { value: 3, label: "Supervisor" },
      { value: 4, label: "Atendente" }
    );
  } else if (currentUserLevel === 2) {
    // Gerente pode criar supervisor e atendente
    levels.push(
      { value: 3, label: "Supervisor" },
      { value: 4, label: "Atendente" }
    );
  } else if (currentUserLevel === 3) {
    // Supervisor pode criar apenas atendente
    levels.push({ value: 4, label: "Atendente" });
  }

  return levels;
};

// Obter badge de status do usuário
export const getUserStatusBadge = (user) => {
  if (!user.is_active) {
    return { variant: "secondary", text: "Inativo" };
  }

  if (user.is_superuser) {
    const level = SUPERUSER_LEVELS[user.superuser_level];
    const variants = {
      1: "primary", // Admin
      2: "warning", // Gerente
      3: "info", // Supervisor
      4: "success", // Atendente
    };

    return {
      variant: variants[user.superuser_level] || "primary",
      text: level || "Superusuário",
    };
  }

  return { variant: "danger", text: "Usuário" };
};

// Verificar se campo é obrigatório baseado no nível
export const isFieldRequired = (fieldName, superuserLevel) => {
  const requiredFields = ["first_name", "last_name", "phone"];

  // CPF é obrigatório para superusuários
  if (fieldName === "cpf" && superuserLevel > 0) {
    requiredFields.push("cpf");
  }

  return requiredFields.includes(fieldName);
};
